import { render } from "./BookingFormFb.vue?vue&type=template&id=b2dfd258"
import script from "./BookingFormFb.vue?vue&type=script&lang=js"
export * from "./BookingFormFb.vue?vue&type=script&lang=js"

import "./BookingFormFb.vue?vue&type=style&index=0&id=b2dfd258&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__